<div class="ic1-my-16">
  <ng-ui-kit-accordion
    [disabled]="!showStep1"
    [title]="'ACTIVATION_STEPS_PAGE.FORCE_PWD_STEP.TITLE' | translate"
    [icon]="!showStep1 ? 'check' : ''"
    [open]="showStep1"
    [step]="showStep1 ? 1 : 0">
    <ng-container content>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="ic1-row">
          <div
            class="ic1-col-12 desc ic1-my-12"
            [HTMLTranslate]="'ACTIVATION_STEPS_PAGE.FORCE_PWD_STEP.DESC'"></div>

          <formly-form
            [form]="form"
            [fields]="fields"
            [model]="model"
            [options]="formOptions"></formly-form>

          <div class="ic1-col-12 buttons-container ic1-mt-16">
            <ng-ui-kit-button
              color="secondary"
              [label]="
                'ACTIVATION_STEPS_PAGE.FORCE_PWD_STEP.BTN_CANCEL' | translate
              "
              type="button"
              size="sm"
              (onClick)="clearForm()">
            </ng-ui-kit-button>

            <app-submit-button
              type="submit"
              [label]="
                'ACTIVATION_STEPS_PAGE.FORCE_PWD_STEP.BTN_CONFIRM' | translate
              "
              [disabled]="loading">
            </app-submit-button>
          </div>
        </div>
      </form>
    </ng-container>
  </ng-ui-kit-accordion>
</div>
